module.exports = __webpack_public_path__ + "img/logo.2b3a61c3.png";